/**
 * Returns the participant count for a survey using the same rules everywhere.
 */
export function getSurveyParticipantsCount(survey, options = {}) {
  if (!survey) return 0;

  const count = survey.attemptedUsersCount;
  if (count !== undefined && count !== null && !Number.isNaN(Number(count))) {
    return Number(count);
  }

  const attendedUsers = options.attendedUsers ?? survey.attendedUsers;
  if (Array.isArray(attendedUsers)) {
    return attendedUsers.length;
  }

  if (Array.isArray(survey.users)) {
    return survey.users.length;
  }

  if (typeof attendedUsers === 'number' && !Number.isNaN(attendedUsers)) {
    return attendedUsers;
  }

  return 0;
}
